module.exports = __webpack_public_path__ + "media/banner.df0c4421.mp4";